import { actionCreator } from 'utils/redux';
export const setUpdateState = actionCreator('SET_UPDATE_STATE');
export const setLobbyModal = actionCreator('SET_LOBBY_MODAL');
export const checkExtensionInstall = actionCreator('CHECK_EXTENSION_INSTALL');
export const setPopupPlayer = actionCreator('SET_POPUP_PLAYER');
